module.exports = __webpack_public_path__ + "static/media/galleryGT (9).f9ff4f69.jpg";